﻿'use strict';

/**
 * @ngdoc service
 * @name ntmApp.ForecastingFiltersProvider
 * @description
 * # ForecastingFiltersProvider
 * Service in the ntmApp.
 */

angular.module('ntmApp')
  .factory('ForecastingFiltersProvider', ['$http', '$q', function ($http, $q) {

      var filters = {
            loaded: false
      };

      function loadFilters(fullReload) {

          var deferred = $q.defer();

          if (filters.loaded && !fullReload) {
              deferred.resolve(angular.copy(filters.data));
          } else {
              $http.get('/api/Forecast/GetBaseFilters').then(function (result) {
                  
                  filters.loaded = true;
                  filters.data = result.data;
                  sessionStorage.forecastingBaseFilters = angular.toJson(filters.data);
                  deferred.resolve(angular.copy(filters.data));
              });
          }
          return deferred.promise;
      }

      function init() {

          if (sessionStorage.forecastingBaseFilters) {
              filters.data = angular.fromJson(sessionStorage.forecastingBaseFilters);
              filters.loaded = true;
          }

      }

      function dispose() {
          filters = {
              loaded: false
          };

          sessionStorage.forecastingBaseFilters = null;
      }

      init();

      var provider = {};

      provider.LoadFilters = loadFilters;
      provider.Dispose = dispose;

      return provider;
  }]);